import React, { useState } from "react";
import { i18nInit } from "translations/i18n";

const Lang = () => {
  const [langInfo, setLangInfo] = useState([
    {
      code: "vn",
      name: "Vietnamese",
      active: true,
    },
    {
      code: "eng",
      name: "English",
      active: false,
    },
  ]);
  const handleLangChange = (i) => {
    switch (i) {
      case 0:
        let newLang = [
          {
            code: "vi",
            name: "Vietnamese",
            active: true,
          },
          {
            code: "eng",
            name: "English",
            active: false,
          },
        ];

        setLangInfo(newLang);
        i18nInit.changeLanguage("vi");
        break;
      default:
        let newLang1 = [
          {
            code: "vi",
            name: "Vietnamese",
            active: false,
          },
          {
            code: "eng",
            name: "English",
            active: true,
          },
        ];

        setLangInfo(newLang1);
        i18nInit.changeLanguage("en");
        break;
    }
  };
  return (
    <>
      <div id="lang">
        <span>Change Language: </span>
        <div>
          {langInfo.map((lang, i) => (
            <span
              className={`lang-tag ${lang.active ? "active" : ""}`}
              onClick={() => handleLangChange(i)}
              key={lang.name + i}
            >
              {lang.name}
            </span>
          ))}
        </div>
      </div>
    </>
  );
};

export default Lang;
